import React, { useContext } from 'react';
import { View, StyleSheet, FlatList } from 'react-native';
import BallotCard from './BallotCard';
import { Status, MainColors } from '../constants/Colors';
import { formatUtcDate } from '../utils/dateUtils';
import FontSizes from '../constants/FontSizes';
import LoadingIndicator from './ActivityIndicator';
import { OrganizationContext } from '../context/OrganizationProvider';
import TwoLineMessage from './TwoLineMessage';
import useInfiniteScroll from '../utils/useInfiniteScroll'
import useFetch from '../utils/useFetch'

const BallotsList = ({ navigation, ...props }) => {
    const { get } = useFetch()
    const { organizationId } = useContext(OrganizationContext)

    const pageSize = 50
    const getBallots = async (pageNumber) => await get(`/api/ballots?showDeleted=${props.showDeleted}&filterStatus=${props.filterStatus}&organizationId=${organizationId}&page=${pageNumber}&count=${pageSize}`)

    const [ballotsList, onScrollPage, onRefresh, isRefreshing] = useInfiniteScroll(getBallots)

    const getStatusColor = (ballotStatus) => {
        switch (ballotStatus) {
            case 'Active':
                return { color: Status.active }
                break;
            case 'Pending':
                return { color: Status.pending }
                break;
            case 'Cancelled':
                return { color: Status.cancelled }
                break;
            case 'Completed':
                return { color: Status.complete }
                break;
            default:
                return { color: MainColors.darkGray }
                break;
        }
    }

    const getStatusLabel = (ballotStatus) => {
        switch (ballotStatus) {
            case 'Completed':
                return 'The results are in! 🎉'
                break;
            default:
                return ballotStatus
                break;
        }

    }


    console.log(ballotsList?.length)
    return (
        <View style={styles.container}>
            <LoadingIndicator isLoading={isRefreshing}>
                {ballotsList && ballotsList.length > 0 ? (
                    <FlatList
                        contentContainerStyle={{ padding: 20 }} // fix for shadow getting clipped (android)
                        style={styles.cardsList}
                        data={ballotsList}
                        keyExtractor={(item) => item.id.toString()}
                        ListFooterComponent={props.ListFooterComponent}
                        ListFooterComponentStyle={{ marginTop: 10 }}
                        onEndReached={onScrollPage}
                        onEndReachedThreshold={5}
                        onRefresh={onRefresh}
                        refreshing={isRefreshing}

                        // these properties help with items not showing up when scrolling quickly
                        // see https://medium.com/sanjagh/how-to-optimize-your-react-native-flatlist-946490c8c49b
                        windowSize={51}
                        maxToRenderPerBatch={25}
                        updateCellsBatchingPeriod={20}

                        renderItem={({ item }) => (
                            <BallotCard
                                disabled={props.cardPressDisabled}
                                editButtonShown={props.editButtonShown}
                                onEditButtonPress={() => props.onEditButtonPress(item.id)}
                                onPress={() => props.onCardPress(item.id)}
                                cardTitle={item.title}
                                startDate={formatUtcDate(item.startDate)}
                                endDate={formatUtcDate(item.endDate)}
                                progressDecimal={parseFloat(item.progress)}
                                statusLabel={getStatusLabel(item.status)}
                                statusStyle={getStatusColor(item.status)}
                                hasBeenVotedOn={item.hasBallotBeenVotedOnByCurrentUser}
                                timeRemaining={item.timeStatus}
                            />
                        )}
                    />
                ) : (
                        <TwoLineMessage
                            firstLine={props.noBallotsMessageLineOne}
                            secondLine={props.noBallotsMessageLineTwo}
                            createMode={props.createMode}
                            onButtonPress={props.onEmptyBallotListCreateBtnPress}
                            buttonText='Create New Ballot'
                            buttonAccessibilityLabel='Create new ballot'
                            accessibilityHint='Press this button to create a new ballot'
                        />
                    )
                }
            </LoadingIndicator>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center'
    },
    cardsList: {
        width: '100%'
    },
    textContainer: {
        marginVertical: 30,
        alignItems: 'center'
    },
    emptyBallotsTextOne: {
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        lineHeight: 30,
        paddingBottom: 8,
        textAlign: 'center',
        fontWeight: '600',
        letterSpacing: 0.5,
        lineHeight: 24
    },
    emptyBallotsTextTwo: {
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        textAlign: 'center',
        letterSpacing: 0.5,
    }
});

export default BallotsList;